import * as Icons from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { Calculator as DefaultIcon } from "lucide-react";

export function Icon({ name, className, size = 20 }: { name: string; className?: string; size?: number }) {
  const Cmp = (Icons as unknown as Record<string, LucideIcon>)[name] ?? DefaultIcon;
  return <Cmp className={className} size={size} />;
}
